import { MessageBox } from 'element-ui'

window.PC = window.PC || {}

window.PC = {
  setLang: function(zh, en) {
    window.PC.lang = {zh, en}
  },
  $t2: function(key){
    let language = localStorage.getItem('language') || 'zh'
    let keys = key.split(".")
    let values = null
    let value = ''
    if(language === 'zh') {
      values = window.PC.lang.zh
    } else {
      values = window.PC.lang.en
    }
    keys.forEach(item => {
      try {
        value = values[item]
        values = value
      } catch(e) {
        return ''
      }
    })
    return value
  },
  noUnregisteredDiag(fn, fn2, msg='comingSoon2', btnText='resiInfo') {
    MessageBox.confirm(
      window.PC.$t2(msg),
      window.PC.$t2('footprints.tips'),
      {
        confirmButtonText: window.PC.$t2(btnText),
        type: 'warning',
      }
    ).then(() => {
      fn && fn()
    }).catch(() => {
      fn2 && fn2()
    })
  },
  $alter(params, fn) {
    MessageBox.alert(params.message, params.title, params).then(() => {
      fn && fn()
    }).catch(() => {})
  },
  FileNameTimeStamp(file) {
    let filename = file
    let index1 = filename.lastIndexOf(".")
    let index2 = filename.length
    let type = filename.substring(index1,index2)
    let name = filename.substring(0, index1)
    //name = name.replace(/,/g, '')
    name = parseInt(Math.random()*100000000)
    filename = 'mianliao/' + name + "_" + (new Date()).valueOf() + type
    return filename
  },
  findItem(getList, key, value, returnKey, callback) {
    let timer = null
    timer = setInterval(() => {
      let list = getList()
      if(list.length > 0) {
        clearInterval(timer)
        timer = null
        const data = list.filter(item => {
          return item[key] == value
        })
        if(data.length > 0) {
          callback && callback(data[0][returnKey])
          return data[0][returnKey]
        }
      }
    }, 10)
  },
  ajaxAfter(getData, callback) {
    let timer = null
    timer = setInterval(() => {
      let list = getData()
      if(list.length > 0) {
        clearInterval(timer)
        timer = null
        callback && callback(list)
      }
    }, 10)
  }
}